import useFacilityItemById from "../../../../../api/hooks/hooks-reit-facility/use-facility-by-id";
import { SQ_METER_SIGN } from "../../../../../lib/constants";
import {
  DateFormat,
  getImgFromObjectFacility,
  UTCtoLocal,
} from "../../../../../lib/utils";
import Button from "../../../../ui/button";
import AboutApartment from "./AboutApartment";
import AboutBuilding from "./AboutBuilding";
import Features from "./Features";
import styles from "./styles.module.scss";
import Loader from "../../../../ui/loader";
import FacilityCardTradeInModal from "../modals/tradeInModal";
import FacilityCardBuyModal from "../modals/buyModal";
import useFacilityReport from "../../../../../api/hooks/hooks-reit-facility/use-facility-get-report";
import useOpenModal from "../../../../ui/modal/hooks/useOpenModal";
import ImageGallery, { IImage } from "../../../../ui/imgGallery";

interface FacilityCard {
  id: number;
}

const ICON_PER_SQUARE = "./icons/icon-per-square.svg";
const ICON_BEDROOM_COUNT = "./icons/icon-bedroom-count.svg";
const ICON_CLOCK = "./icons/icon-clock.svg";

const FacilityCard = ({ id }: FacilityCard) => {
  const {
    offsetY: offsetYBuy,
    open: openBuy,
    handleChangeModal: handleChangeModalBuy,
  } = useOpenModal();

  const {
    offsetY: offsetYTradeIn,
    open: openTradeIn,
    handleChangeModal: handleChangeModalTradeIn,
  } = useOpenModal();

  const handleOpenTradeIn = (isOpen: boolean) => {
    handleChangeModalTradeIn(isOpen);
  };

  const handleOpenBuy = (isOpen: boolean) => {
    handleChangeModalBuy(isOpen);
  };

  const { data, error, isLoading, mutate } = useFacilityItemById(id);
  const { isMutating, trigger } = useFacilityReport(id, data?.title);

  const imgs:IImage[] = data ? getImgFromObjectFacility(data) : [];

  if (isLoading) {
    return (
      <div className={styles.facilityCard__loader}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={styles.facilityCard}>
      <div className={styles.facilityCard__container}>
        {imgs.length > 0 && (
          <div className={styles.facilityCard__left}>
            <div className={styles.facilityCard__carousel}>
              <ImageGallery images={imgs} />
            </div>
            <div className={styles.facilityCard__report}>
              <Button
                variant="dark"
                onClick={() => trigger()}
                label="Скачать отчет по квартире"
                loading={isMutating}
              />
            </div>
          </div>
        )}

        <div className={styles.facilityCard__right}>
          <div className={styles.facilityCard__title}>{data?.title}</div>
          <div className={styles.facilityCard__feature}>
            <Features
              items={[
                {
                  icon: ICON_PER_SQUARE,
                  label: "Общая",
                  value: `${data?.areaInSqM} ${SQ_METER_SIGN}`,
                },
                {
                  icon: ICON_BEDROOM_COUNT,
                  label: "Комнаты",
                  value: data?.roomCount,
                },
                {
                  icon: ICON_CLOCK,
                  label: "Построен",
                  value: data?.building?.commissioningYear
                    ? UTCtoLocal(
                        String(data?.building?.commissioningYear),
                        DateFormat.year
                      )
                    : "Неизвестно",
                },
              ]}
            />
          </div>

          {data && (
            <div className={styles.facilityCard__aboutApartment}>
              <AboutApartment {...data} />
            </div>
          )}

          {data?.building && (
            <div className={styles.facilityCard__aboutBuilding}>
              <AboutBuilding {...data?.building} />
            </div>
          )}

          <div className={styles.facilityCard__buttons}>
            <Button label="Хочу на просмотр" onClick={(event) => handleOpenBuy(true)} />
            <Button
              label="ТРЕЙД-ИН"
              variant="dark"
              onClick={(event) => handleOpenTradeIn(true)}
            />
            {!imgs.length && (
              <Button
                variant="dark"
                onClick={() => trigger()}
                label="Скачать отчет по квартире"
                loading={isMutating}
              />
            )}
          </div>
        </div>
      </div>
      {data && (
        <>
          <FacilityCardTradeInModal
            id={id}
            onClose={(value) => handleOpenTradeIn(value)}
            offsetY={offsetYTradeIn}
            opened={openTradeIn}
            marketType={data.marketType}
          />
          <FacilityCardBuyModal
            id={id}
            onClose={(value) => handleOpenBuy(value)}
            offsetY={offsetYBuy}
            opened={openBuy}
            marketType={data.marketType}
          />
        </>
      )}
    </div>
  );
};

export default FacilityCard;
